function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("title", null, "Group 2");
var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");
var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "square"
}, /*#__PURE__*/React.createElement("g", {
  id: "Map-details",
  transform: "translate(-1396.000000, -214.000000)",
  stroke: "#444444",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(1397.500000, 215.500000)"
}, /*#__PURE__*/React.createElement("line", {
  x1: 0.5,
  y1: 0.5,
  x2: 11.5,
  y2: 11.5,
  id: "Line-5"
}), /*#__PURE__*/React.createElement("line", {
  x1: 11.5,
  y1: 0.5,
  x2: 0.5,
  y2: 11.5,
  id: "Line-5"
}))));
const SvgClose = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgClose, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/close.fd43731d.svg";
export { ForwardRef as ReactComponent };